
import { GameObjects } from "phaser";

export class GButton extends GameObjects.Container {

    constructor(scene, x, y, config) {
        super(scene, x, y);

        // Add this container to the scene
        scene.add.existing(this);

        // Default configuration
        const { texturePack, idleTexture, hoverTexture, clickedTexture, disabledTexture, text, icon, onClick, isDisabled, isSelected , selectedTexture , nineslice, clickEvent } = config;
        this.isSprite = true
        // Create the button sprite with the idle texture
        if(idleTexture){
            if(nineslice){
                this.buttonSprite = scene.add.nineslice(0, 0, texturePack, idleTexture, 343*2, 104, 32, 32);
            }else {
                this.buttonSprite = scene.add.sprite(0, 0, texturePack ,idleTexture);
            }

            this.add(this.buttonSprite);
        }



      
        let lastClickTime = 0;  // Track the last click timestamp (for debounce)
        const debounceDelay = 50; // Minimum time between clicks in ms

        
        this.buttonClickSound = scene.sound.add('button-click');
        //this.buttonSprite = scene.add.sprite(0,0,texturePack, idleTexture).setInteractive();
        //this.buttonSprite =   scene.add.sprite(0, 0, "pack", "Header 1 - Button BG - Clicked.png");
        // console.log(0, 0, texturePack ,idleTexture)
        // console.log(0, 0, 'pack', 'Header 1 - Button BG - Default.png')
       
        // Add button sprite to the container
      

        this.allTexts = text;

        // Add optional text to the button
        if (text) {
            this.label = scene.add.text(0, 0, text.value, text.style).setOrigin(0.5);
            this.label.setFontStyle("700")
            this.add(this.label);
        }

      

        // Store the different states of the button
        this.texturePack = texturePack;
        this.idleTexture = idleTexture;
        this.hoverTexture = hoverTexture;
        this.clickedTexture = clickedTexture;
        this.disabledTexture = disabledTexture;
        this.selectedTexture = selectedTexture || clickedTexture;
        this.isDisabled = isDisabled || false;
        this.selected = isSelected || false;
        this.clickEvent = clickEvent || "post"

        // Set initial state
        if (this.isDisabled) {
            this.setDisabled();
        } else {
            this.setIdle();
        }

        // // Set up interactive states
        // this.buttonSprite.on('pointerover', () => {
        //     if (!this.isDisabled) {
        //         this.setHover();
        //     }
        // });

        // this.buttonSprite.on('pointerout', () => {
        //     if (!this.isDisabled) {
        //         this.setIdle();
        //     }
        // });

        // Capture the original scale of the button
        this.originalScaleX = this.scaleX;
        this.originalScaleY = this.scaleY;

     

        const bounds = this.getBounds();
        // this.borderGraphics = scene.add.graphics();
        // this.borderGraphics.lineStyle(2, 0xff0000); // 2px width, red color
        // this.borderGraphics.strokeRect(bounds.x, bounds.y, bounds.width, bounds.height);
        //console.log('Button bounds:', bounds);


  // Add optional icon to the button
  if (icon) {
    //this.icon = scene.add.image(0, 0, icon).setOrigin(0.5);
    this.iconX = 0

    if(icon.align !== undefined){
        if(icon.align == 'left'){
            //this.iconX = this.getBounds().width/2 * - 1 + 44
            //this.iconX = bounds.width/2 * - 1 + 44
            if(icon.x !== undefined){
                this.iconX -= this.label.width - 36
                this.label.x += 32
            } else {
                //this.iconX =  this.iconX + this.label.width/2 + 36
                this.iconX = bounds.width/2 * - 1 + 44
                this.label.x += 16
            }

            //this.label.x += this.iconX + this.label.width/2
        } 

       
        
    }
    
    this.icon = scene.add.sprite(this.iconX, 0, texturePack ,icon.image);
    this.icon.setScale(icon.scale)
    this.add(this.icon);
}


        this.setSize(bounds.width, bounds.height);

        if(!this.buttonSprite){
            this.buttonSprite = scene.add.rectangle(bounds.width/2, 0, bounds.width, bounds.height, 0xff6699,0);
            this.add(this.buttonSprite);
            this.isSprite = false
        }

        //new Phaser.Geom.Rectangle(-16, -16, bounds.width, bounds.height), Phaser.Geom.Rectangle.Contains

        this.buttonSprite.setInteractive();


        this.buttonSprite.on('pointerdown', () => {
            if (!this.isDisabled) {
                const now = Date.now();
                if (now - lastClickTime > debounceDelay) {
                    this.buttonClickSound.play();
                    this.setClicked();
                    scene.tweens.add({
                        targets: this,
                        scaleX: this.originalScaleX * 0.85,
                        scaleY: this.originalScaleY * 0.85,
                        duration: 50, // Duration of the tween (in milliseconds)
                        ease: 'Power2'
                    });
                }
              
            }
        });

        this.buttonSprite.on('pointerup', () => {

            const now = Date.now();
            if (now - lastClickTime > debounceDelay) {
                lastClickTime = now; // Update the last click time
                if (onClick && this.clickEvent == "pre") onClick();
                scene.tweens.add({
                    targets: this,
                    scaleX: this.originalScaleX,
                    scaleY: this.originalScaleY,
                    duration: 50, // Duration of the tween (in milliseconds)
                    ease: 'Power2',
                    onComplete: () => {
                        if(!this.isDisabled && !this.isSelected){
                            this.setIdle();
                        }
                        if (onClick && this.clickEvent == "post") onClick();
                        // Trigger the custom function after the tween completes
                        // Call the provided callback function
                      
                    }
                });

            }

              
            
        });

        this.buttonSprite.on('pointerout', () => {
            if(!this.isSelected){
                this.setIdle();
                scene.tweens.add({
                    targets: this,
                    scaleX: this.originalScaleX ,
                    scaleY: this.originalScaleY,
                    duration: 50, // Duration of the tween (in milliseconds)
                    ease: 'Power2'
                });            
            }
                
        });

        // this.setInteractive(new Phaser.Geom.Circle(0, 0, 60), Phaser.Geom.Circle.Contains);

        // this.on('pointerover', () =>
        //     {
    
        //         console.log("pointerover")
    
        //     });

    }

     // Override the setScale method
     setScale(x, y = x) {
        // Custom behavior: Log or handle events when setScale is called
        //console.log(`setScale called with x: ${x}, y: ${y}`);

        // Call the original setScale method to ensure normal behavior
        super.setScale(x, y);

        const bounds = this.getBounds();
        this.setSize(bounds.width, bounds.height);
        //this.setInteractive(new Phaser.Geom.Rectangle(-32, -16, bounds.width, bounds.height), Phaser.Geom.Rectangle.Contains);
        
        // this.borderGraphics.clear();
        // this.borderGraphics.lineStyle(2, 0xff00ff); // 2px width, red color
        // this.borderGraphics.strokeRect(bounds.x, bounds.y, bounds.width, bounds.height);
        // Optionally trigger any other actions you want when setScale is called
        this.onScaleChanged(x, y); // Custom event or behavior
    }

    // Custom method to handle scale changes
    onScaleChanged(newScaleX, newScaleY) {
        this.originalScaleX = newScaleX;
        this.originalScaleY = newScaleY;
        //console.log(`Container's scale has been changed to X: ${newScaleX}, Y: ${newScaleY}`);
        // You can handle custom logic here, like adjusting children positions, etc.
    }

    // Set the button to idle state
    setIdle() {
        if(this.isSprite && this.buttonSprite){
            this.buttonSprite.setTexture(this.texturePack, this.idleTexture);
        }
        if(this.label){
            this.label.setColor(this.allTexts.style.color);
        }
    }

    // // Set the button to hover state
    // setHover() {
    //     if (this.hoverTexture) {
    //         this.buttonSprite.setTexture(this.hoverTexture);
    //     }
    // }

    // Set the button to clicked state
    setClicked() {
        if (this.clickedTexture) {
            if(this.isSprite && this.buttonSprite){
                this.buttonSprite.setTexture(this.texturePack, this.clickedTexture);
            }
        }

        if(this.label &&  this.allTexts.styleSelected !== undefined){
            this.label.setColor(this.allTexts.styleSelected.color);
        }
    }

    // Set the button to disabled state
    setDisabled() {
        if (this.disabledTexture) {
            if(this.isSprite){
                this.buttonSprite.setTexture(this.texturePack, this.disabledTexture);
            }
        }

        if(this.label &&  this.allTexts.styleDisabled !== undefined){

            this.label.setColor(this.allTexts.styleDisabled.color);
        }


        this.isDisabled = true;
        this.buttonSprite.disableInteractive();
    }

    // Enable the button
    enable() {
        this.isDisabled = false;
        const bounds = this.getBounds();
        this.buttonSprite.setInteractive();
        this.setIdle();
        if(this.label){
            this.label.setColor(this.allTexts.style.color);
        }
    }

    setSelected(){
        //console.log("pointerout", this.isSelected)
        this.isSelected = !this.isSelected;
        if(this.isSelected){
            if(this.isSprite){
                this.buttonSprite.setTexture(this.texturePack, this.selectedTexture);
            }
            if(this.label &&  this.allTexts.styleSelected !== undefined){
                this.label.setColor(this.allTexts.styleSelected.color);
            }
        }else{
            if(this.isSprite){
                this.buttonSprite.setTexture(this.texturePack, this.idleTexture);
            }
            if(this.label){
                this.label.setColor(this.allTexts.style.color);
            }

        }

        
    }

    setOriginOver(x,y){
        this.setOrigin(x,y);
    }
}